/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portals_Verify_FailedInputs */

const cs_portals_verify_failed = /** @type {(inputs: Portals_Verify_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ověření publikace našlo problém`)
};

const en_portals_verify_failed = /** @type {(inputs: Portals_Verify_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Publication verification found a problem`)
};

/**
* | output |
* | --- |
* | "Publication verification found a problem" |
*
* @param {Portals_Verify_FailedInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const portals_verify_failed = /** @type {((inputs?: Portals_Verify_FailedInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portals_Verify_FailedInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_portals_verify_failed(inputs)
	return cs_portals_verify_failed(inputs)
});